import { render } from "./limitViewPopup.vue?vue&type=template&id=d782fa5e&scoped=true"
import script from "./limitViewPopup.vue?vue&type=script&lang=js"
export * from "./limitViewPopup.vue?vue&type=script&lang=js"

import "./limitViewPopup.vue?vue&type=style&index=0&id=d782fa5e&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d782fa5e"]])

export default __exports__